import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import ImageViewer from 'components/field/ImageViewer';
import Accordion from 'components/global/Accordion';
import Alert from 'components/global/Alert';
import Loading from 'components/global/Loading';
import Typography from 'components/global/Typography';

import * as S from 'pages/OtherIntegrations/Integrations/Modals/WhatsappBusiness/WhatsappBusinessModal.styled';

const LinkViewer = ({ children }) => {
	const { t } = useTranslation();
	return <a href={children}>{t(children)}</a>;
};

const WhatsappBusinessInstructions = ({ isLoading }) => {
	const instructions = useMemo(
		() => [
			'whatsapp.instructionsStep1',
			'whatsapp.instructionsStep2',
			'whatsapp.instructionsStep3',
			'whatsapp.instructionsStep4',
			'whatsapp.instructionsStep5',
			'whatsapp.instructionsStep6',
			'whatsapp.instructionsStep7'
		],
		[]
	);

	return (
		<S.InstructionsCard className="instructions">
			<Alert content="whatsapp.instructionsTitle" showIcon />
			<AccordionSection instructions={instructions} />
			{isLoading && <Loading />}
		</S.InstructionsCard>
	);
};

export const AccordionSection = ({ instructions }) => {
	const { t } = useTranslation();

	return (
		instructions &&
		instructions.map((instruction, index) => (
			<Accordion header={t('stepNumber', { step: index + 1 })} defaultVisible={index === 0} key={index}>
				<Typography noWrap>
					<Trans
						i18nKey={instruction}
						components={{
							image: <ImageViewer />,
							linkViewer: <LinkViewer />
						}}
					/>
				</Typography>
			</Accordion>
		))
	);
};

export default WhatsappBusinessInstructions;
